import {Category} from "../category/category";
import {Media} from "../media/media";

export enum EVatRate {
    Vat22,
    Rv17
}

export class Addon {
    constructor() {
        this.id = '';
        this.name = '';
        this.options = new Array<Option>();
        this.quantityModifiable = '';
        this.sku = '';
        this.sequence = 0;
        this.duplicable = false;
        this.addonPrice = 0;
        this.obligatory = 0;
    }
    id: string;
    name: string;
    options: Array<Option>;
    quantityModifiable: string;
    sku: string;
    sequence: number;
    addonPrice: number;
    duplicable: boolean;
    obligatory: number;
}

export class AddonHelper {
    constructor() {
        this.id = '';
        this.addon = new Addon();
        this.deletable = false;
    }
    id: string;
    addon: Addon;
    deletable: boolean;
}

export class Option {
    constructor() {
        this.id = '';
        this.name = '';
        this.parentSku = '';
        this.sku = '';
        this.sequence = 0;
        this.price = 0;
        this.stock1 = 0;
        this.stock2 = 0;
        this.stock3 = 0;
        this.obligatory = 0;
    }
    id: string;
    name: string;
    parentSku: string;
    sku: string;
    sequence: number;
    price: number;
    stock1: number;
    stock2: number;
    stock3: number;
    obligatory: number;
}

export class OptionalAddonPrice {
    constructor() {
        this.id = '';
        this.productOption = new ProductOption();
        this.addon = new Addon();
    }
    id: string;
    productOption: ProductOption;
    addon: Addon;
}

export class Product {
    constructor() {
        this.id = '';
        this.name = '';
        this.shortDescription = '';
        this.description = '';
        this.status = '';
        this.sku = '';
        this.internalCode = '';
        this.model = '';
        this.maker = '';
        this.stock1 = 0;
        this.stock2 = 0;
        this.stock3 = 0;
        this.images = new Array<Media>();
        this.options= new Array<Option>();
        this.quantity = 0;
        this.price = 0;
        this.arrivingQuantity = 0;
        this.arrivingQuantityDate = "";
        this.discountedPrice = 0;
        this.categories = new Array<Category>();
        this.configurable = false;
        this.taxSIAE = 0;
        this.vatRate = EVatRate.Vat22;
    }
    
    id: string;
    name: string;
    shortDescription: string;
    description: string;
    status: string;
    sku: string;
    internalCode: string;
    model: string;
    maker: string;
    stock1: number;
    stock2: number;
    stock3: number;
    images: Array<Media>;
    options: Array<Option>;
    quantity: number;
    arrivingQuantity: number;
    arrivingQuantityDate: string;
    price: number;
    discountedPrice: number;
    categories: Array<Category>;
    configurable: boolean;
    taxSIAE: number;
    vatRate: EVatRate;
}

export class ProductOption {
    constructor() {
        this.id = '';
        this.name = '';
        this.quantityModifiable = true;
        this.defaultQuantity = 0;
        this.addons = new Array<string>();
        this.selectedAddon = new Addon();
        this.addonPrice = 0;
        this.selectedQuantity = 0;
    }
    id: string;
    name: string;
    quantityModifiable: boolean;
    defaultQuantity: number;
    addons: Array<string>;
    selectedAddon: Addon;
    addonPrice: number;
    selectedQuantity: number;
}

export class ProductPrice {
    constructor() {
        this.listingId = '';
        this.productId = '';
        this.price = 0;
        this.discountedPrice = 0;
    }
    listingId: string;
    productId: string;
    price: number;
    discountedPrice: number;
}

export class Filter {

    constructor() {
        this.name = "";
        this.values = new Array<FilterValue>();
    }

    name: string;
    values: Array<FilterValue>;
}

export class FilterValue {
    constructor() {
        this.value = "";
        this.active = false;
    }

    value: string;
    active: boolean;
}
